import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';

import Button from '../button/button.component';
import Warning from './Warning';

import './error-display.styles.scss';

// error object structure = {
//   message: String,
//   show: Boolean,
//   error: Error instance,
//   extraInfo: Object with extra info that is useful
// }

export default function ErrorDisplay({ error, setError, iconBtnStyles={} }) {
  const [showCause, setShowCause] = useState(false);

  function closeDisplay() {
    setError({ ...error, show: false });
  }

  function openDisplay() {
    setError({ ...error, show: true });
  }

  function toggleShowCause() {
    setShowCause(!showCause);
  }

  function handleClearData() {
    if (window.confirm('Are you sure that you want to reset the data for this site? You will lose ALL locations, options, etc. It will be like visiting the site for the first time, and this operation cannot be undone.')) {
      localStorage.clear();
      window.location.reload();
    }
  }

  return (
    <React.Fragment>
      <div style={iconBtnStyles}>
        <button
          onClick={openDisplay}
          className='icon-btn'
        >
          <Warning fillColor='white' />
        </button>
      </div>

      <Dialog
        open={error.show}
        onClose={() => null}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }} id="alert-dialog-title">An error has occurred</DialogTitle>
        <DialogContent sx={{ margin: '0px 8px', border: '1px solid rgb(240,240,240)' }}>
          <DialogContentText sx={{ marginTop: '6px' }} id="alert-dialog-description">Something has gone wrong while attempting to load your data or make your requested changes.</DialogContentText>
          <DialogContentText sx={{ marginTop: '6px' }}>Click "Okay" to close this dialog box. The data shown may not be accurate. Either undo the change that you made or refresh the page to ensure data accuracy.</DialogContentText>
          <DialogContentText sx={{ marginTop: '6px' }}>Click "Show Error" to what might have gone wrong. This is useful information when seeking support from the website maintainers.</DialogContentText>
          <DialogContentText sx={{ marginTop: '6px' }}>If you continue to recieve this dialog box you may need to click "Clear Data" to clear all options and locations.</DialogContentText>
        </DialogContent>
        <DialogActions className='dialog-actions'>
          <div className='action-group'>
            <Button onClick={handleClearData} buttonType='errorBtn'>Clear Data</Button>
            <Button onClick={toggleShowCause} buttonType='errorBtn'>{showCause ? 'Hide' : 'Show'} Error</Button>
          </div>

          <Button onClick={closeDisplay} buttonType='acceptBtn'>Okay</Button>
        </DialogActions>
        {showCause ?
          <DialogContent sx={{ margin: '0px 8px', border: '1px solid rgb(240,240,240)' }}>
            <DialogContentText sx={{ fontSize: '1.1rem', fontWeight: '600' }}>Error: {error.message}</DialogContentText>
            <DialogContentText>{error.error.stack}</DialogContentText>
            <DialogContentText sx={{ marginTop: '12px', fontSize: '1.1rem', fontWeight: '600' }}>Extra Information:</DialogContentText>
            <DialogContentText><pre>{JSON.stringify(error.extraInfo, null, 2)}</pre></DialogContentText>
          </DialogContent>
        : ''}
      </Dialog>
    </React.Fragment>
  );
}